import React from 'react';
import { Link } from 'react-router-dom';

const ProjectTemplateLink = ({ projectTypeId, projectTemplate }) => {
  const href = `/project-types/${projectTypeId}/project-templates/${projectTemplate.id}`;
  return projectTemplate ? (
    <React.Fragment>Created From Template: <Link push to={href} onClick={(e) => e.stopPropagation()}>{`${projectTemplate.name} | V${projectTemplate.version}`}</Link></React.Fragment>
  ) : '';
};

export default ProjectTemplateLink;



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/ProjectHeader/ProjectTemplateLink/index.js